<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "mobile_EmptyLayout",
};
</script>

<style scoped>
div {
  min-height: 100vh;
}
</style>
